import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import React from "react";
import { useUseScheduleWhoDataQuery } from "./useScheduleWhoData.generated.js";

export const useScheduleWhoData = (memberIds: string[]) => {
  const client = useApolloClient();
  const query = useUseScheduleWhoDataQuery({
    client,
    variables: { memberIds, limit: memberIds.length },
    skip: !memberIds.length,
  });

  return React.useMemo(
    () =>
      !memberIds.length
        ? []
        : (getDataOrNull(query.data?.organisationMemberships)?.edges.map(
            e => e.node
          ) ?? []),
    [memberIds.length, query.data?.organisationMemberships]
  );
};
